import { AfterViewInit, Component, Inject, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EvkErrorType, EvkResponseType, MessageCrudService } from "@evomatik/evk-common";
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DiligenciaAsignacionService } from "../services/diligencia-asignacion.service";
import { DiligenciaAsignacionFormComponent } from "./diligencia-asignacion-form/diligencia-asignacion-form.component";

@Component({
    selector: 'diligencia-diligencia-asignacion',
    templateUrl: './diligencia-asignacion.component.html',
    styleUrls: ['./diligencia-asignacion.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DiligenciaAsignacionComponent implements AfterViewInit {

    form: FormGroup;
    title: string;
    idDiligenciaConfig: string;
    peritos: boolean;

    constructor(
        public createService: DiligenciaAsignacionService,
        public messagesCrudService: MessageCrudService,
        public dialogRef: MatDialogRef<DiligenciaAsignacionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.title = this.data.origen;
        this.peritos = this.data.peritos ? this.data.peritos : false;
        this.idDiligenciaConfig = this.data.tarea['detalle']['idDiligenciaConfig'];
    }

    ngAfterViewInit(): void {
        this.createService.idNegocio = this.data.tarea['idNegocio'];
        this.createService.idDiligenciaConfig = this.data.tarea['detalle']['idDiligenciaConfig'];
    }

    @ViewChild(DiligenciaAsignacionFormComponent, {static: false})
    set formComponent(formComponent: DiligenciaAsignacionFormComponent) {
        this.form = formComponent.form;
    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    private doneEdit(response: EvkResponseType) {
        // Se tiene que cerrar el dialog hasta que se guardó la transferencia.
        if ( response.data.detalle && response.data.detalle.mensajeError ){
            this.messagesCrudService.snackbarMessage(response.data.detalle.mensajeError);
        } else {
            this.dialogRef.close(this.form.controls.usuarioDestino.value);
        }
    }

    protected errorEdit(error: EvkErrorType) {
        this.messagesCrudService.snackbarError(error);
    }

    public edit(): void {
        const dialog = this.messagesCrudService.openConfirmDialog({
            warn: '¿Está seguro de asignar está diligencia?'
        });
        dialog.componentInstance.resolveEvent.subscribe((resolve: any) => {
            dialog.close();
            if (this.peritos) {
                this.dialogRef.close();
                this.messagesCrudService.snackbarMessage('Se creara nuevo expediente, se notificara al finalizar');
            } else {
                this.messagesCrudService.snackbarLoading();
            }
            const data = this.form.value;
            data['asignacion'] = this.title === 'Asignar';
            of(data)
                .pipe(
                    switchMap(this.createService.evkOnBeforeEdit.bind(this.createService)),
                    switchMap(this.createService.edit.bind(this.createService))
                )
                .subscribe(
                    this.doneEdit.bind(this),
                    this.errorEdit.bind(this)
                );
        });
    }


}
